import styled from 'styled-components'

const buttonWidth = 40
const buttonMargin = 10

const buttonWidthMobile = 35
const buttonMarginMobile = 5

export const InteractiveContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .pageButton {
    box-sizing: border-box;

    width: ${buttonWidth}px;
    height: ${buttonWidth}px;

    border: 1px solid ${(props) => props.theme.colors.darkgray};
    border-radius: 8px;
    margin: ${buttonMargin}px;
    flex: none;
    background-color: transparent;

    display: flex;
    align-items: center;
    justify-content: center;

    border: 1px solid ${(props) => props.theme.colors.darkgray};

    font-size: ${(props) => props.theme.fontSizes.b3};
    font-weight: ${(props) => props.theme.fontWeights.semibold};

    transition: transform 0.2s ease-in-out;

    &:hover {
      color: ${(props) => props.theme.colors.primary};
      background-color: ${(props) => props.theme.colors.darkgray};
      transform: scale(1.2);
    }
  }

  .selected {
    color: ${(props) => props.theme.colors.primary};
    background-color: ${(props) => props.theme.colors.darkgray};
    transform: scale(1.2);
  }

  @media (max-width: 500px) {
    .pageButton {
      font-size: ${(props) => props.theme.fontSizes.b4};
      width: ${buttonWidthMobile}px;
      height: ${buttonWidthMobile}px;
      margin: ${buttonMarginMobile}px;
    }
  }
`

export const ArrowLeft = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  opacity: ${(props) => (props.active ? 1 : 0.4)};
  transition: transform 0.2s ease-in-out;

  img {
    width: 48px;
    height: 48px;
    transform: rotate(180deg);
  }

  &:hover {
    transform: scale(1.1);
  }
  @media (max-width: 500px) {
    img {
      width: 35px;
      height: 35px;
    }
  }
`

export const ArrowRight = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  opacity: ${(props) => (props.active ? 1 : 0.4)};
  transition: transform 0.2s ease-in-out;

  img {
    width: 48px;
    height: 48px;
  }

  &:hover {
    transform: scale(1.1);
  }

  @media (max-width: 500px) {
    img {
      width: 35px;
      height: 35px;
    }
  }
`
